<div class="p-1 size-card" *ngIf="model">
    <a class="btn btn-box-rounded m-b-20 m-r-10 font-c3 btn-tag-light w-100" style="position: relative;">
        <div>
            <div class="border-bottom p-b-10">
                <!-- Coupon Name -->
                <div class="text-left">
                    <div class="d-flex-between">
                        <div class="font-h7 w-100 pr-1">
                            <span *ngIf="model.name.length > 62">
                                {{model.name.substring(0, 59) + ' ...'}}
                            </span>
                            <span *ngIf="model.name.length <= 62">
                                {{model.name}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="font-c2 text-left" style="padding: 10px 0px;">
                    <span *ngIf="model.description.length <= 150" [innerHTML]="model.description"></span>
                    <ng-container *ngIf="model.description.length > 150">
                        <span [innerHTML]="model.description.substring(0, 150) + ' ...'"></span>
                    </ng-container>
                </div>
            </div>
            <!-- Qty -->
            <div class="text-left drop-down m-t-5">

                <div class="text-left">
                    <div class="d-flex-between align-items-center">
                        <div class="d-flex align-items-center">
                            <button class="btn-circle btn-primary btn-xs" type="button" style="padding-top: 6px"
                                (click)="changeQuantity(false, true)">
                                <i class="fa fa-minus"></i>
                            </button>
                            <span class="p-l-20 p-r-20 font-h5">{{productQuantity}}</span>
                            <button class="btn-circle btn-primary btn-xs" type="button" style="padding-top: 6px"
                                (click)="changeQuantity(true, true)">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="font-14">{{model.price | currency: model.currencySymbol : 'symbol': '3.0'}}</span>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center" [ngClass]="{'close': validCloseAlert, 'd-flex alert-max-quantity' : validShowAlert}">
                    <div *ngIf="maxQuantitySelected > 0">
                        <small>La cantidad máxima es de {{maxQuantitySelected}} ofertas</small>
                    </div>
                    <div *ngIf="maxQuantitySelected == 0">
                        <small>No hay ofertas disponibles</small>
                    </div>
                    <div (click)="closeAlert()" class="m-l-15 cursor-pointer">
                        <small class="m-r-10 text-black font-bold">X</small>
                    </div>
                </div>
            </div>
        </div>
    </a>

    <!-- Totals -->
    <div class="d-flex-between border-bottom m-b-10 m-t-20">
        <div class="font-bold font-12" style="line-height: 24px;">
            <span class="text-left" *ngIf="model.name.length > 45">
                {{model.name.substring(0, 42) + ' ...'}}
            </span>
            <span class="text-left" *ngIf="model.name.length <= 45">
                {{model.name}} x {{model.quantitySelected}}
            </span>
        </div>
        <div class="text-right" style="padding: 0 !important; width: 45px;">
            <span *ngIf="(model.quantitySelected * model.price) > 0" class="font-12">
                {{(model.quantitySelected * model.price) | currency: model.currencySymbol : 'symbol': '3.0'}}
            </span>
            <span *ngIf="(model.quantitySelected * model.price) <= 0" class="font-12">
                Gratis
            </span>
        </div>
    </div>

    <div class="d-flex justify-content-between">
        <!--Total-->
        <div *ngIf="model.priceTotal > 0" class="font-b1 font-bold">
            Total: <b class="text-purple">({{(model.priceTotal) | currency: model.currencySymbol : 'symbol': '3.0'}})</b>
        </div>
    </div>
</div>